import { COMBO_LETTERS, SKATE_LETTERS } from "../game/collectables";

/** The goals and challenges collected as letters, and their words. */
const WORDS: Record<string, readonly string[]> = { skate: SKATE_LETTERS, combo: COMBO_LETTERS };

/**
 * A goal's or challenge's title where it's shown with its letter tiles (#148):
 * the tiles spell the word, so the title doesn't too. Others keep their text.
 */
export function letterTitle(id: string, text: string): string {
  return id === "skate" ? "Collect the letters" : id === "combo" ? "Collect the letters in one combo" : text;
}

/** Which of the word's letters a progress line ("S K · · E", from `Run.letterProgress`) has. */
export function lettersGot(progress: string): boolean[] {
  return progress.split(" ").map((l) => l !== "·" && l !== "");
}

/**
 * The word's letters as five tiles, dim until picked up and lit once got (#148),
 * in place of "S K · · E". Nothing for a goal that isn't letters.
 */
export function LetterTiles({ id, progress, size = "sm" }: { id: string; progress: string | null | undefined; size?: "sm" | "lg" }) {
  const word = WORDS[id];
  if (!word || progress == null) return null;
  const got = lettersGot(progress);
  const have = word.filter((_, i) => got[i]);
  const tile = size === "lg" ? "size-7 text-base" : "size-5 text-xs";
  return (
    <span role="group" aria-label={`Letters got: ${have.length ? have.join(" ") : "none"}`} className="inline-flex gap-1 not-italic">
      {word.map((l, i) => (
        <span
          key={i}
          data-letter={l}
          data-got={Boolean(got[i])}
          className={`grid ${tile} place-items-center rounded-md border-2 border-ink font-black ${got[i] ? "bg-highlight text-ink" : "bg-white/45 text-ink/35"}`}
        >
          {l}
        </span>
      ))}
    </span>
  );
}
